import React from 'react';
import PropTypes from 'prop-types';
import { StyleSheet, css } from 'aphrodite';
import * as FPT from '../utility/fpt';
import { Checkbox, Icon, Link } from '@paypalcorp/pp-react';

const styles = StyleSheet.create({
  toolWrapper: {
    marginTop: '20px',
    position: 'relative',
  },
  toolCheckboxWrapper: {
    position: 'absolute',
    width: 'inherit',
    display: 'inline',
  },
  toolCheckbox: {
    ':before': {
      overflow: 'hidden',
    },
  },
  toolBlurb: {
    fontSize: '15px',
    lineHeight: '20px',
    marginLeft: '40px',
    fontFamily: 'pp-sans-small-regular',
  },
  toolTip: {
    position: 'relative',
    // display: 'none',
    maxWidth: '430px',
    margin: '7.5px auto 5px',
  },
  tipIcon: {
    color: '#005EA6',
    cursor: 'pointer',
    textDecoration: 'none',
  },
  toolTipTxt: {
    backgroundColor: '#e1e7eb',
    fontSize: '12px',
    lineHeight: '1.8',
    textAlign: 'left',
    borderRadius: '6px',
    padding: '5px 7px',
    display: 'block',
  },
});

class AddressCheckBox extends React.Component {
  constructor() {
    super();
    this.state = {
      showToolTip: false,
    };
  }

  handleTipClick = (event) => {
    event.preventDefault();
    let { showToolTip } = this.state;
    this.setState({ showToolTip: (showToolTip = !showToolTip) });
    this.linkWithIcon.focus();
  };

  handleChangeAddress = (ev) => {
    let isChecked = ev.target.checked;
    let chkBxStatus = isChecked ? 'checked' : 'unchecked';
    FPT.trackLinkClickWithData('shareAddress', { checkbox: chkBxStatus });

    this.props.changeAddress(isChecked);
  };

  createLabel = (label) => {
    return (
      <>
        {label}
        <span onClick={this.handleTipClick} className="tooltip-accessible">
          <Link
            href="#"
            aria-labelledby="address-checkbox-label"
            ref={(el) => (this.linkWithIcon = el)}
          >
            <Icon
              name="question-alt"
              size="xs"
              style={{
                color: '#0070ba',
              }}
            ></Icon>
          </Link>
        </span>
      </>
    );
  };

  render() {
    return (
      <div className="ppvx_row mt-12">
        <div className="ppvx_col-sm-12">
          <div className="share-address-checkbox">
            <Checkbox
              id="address-checkbox"
              name="address-checkbox"
              aria-labelledby="address-checkbox-label"
              label={this.createLabel(this.props.label)}
              onChange={this.handleChangeAddress}
            />
          </div>
          {this.state.showToolTip && (
            <div id="toolTip" className={`col-12 ${css(styles.toolTip)}`}>
              <span className={css(styles.toolTipTxt)}>
                {this.props.toolTipText}
              </span>
            </div>
          )}
        </div>
      </div>
    );
  }
}

AddressCheckBox.propTypes = {
  changeAddress: PropTypes.func.isRequired,
  toolTipText: PropTypes.string,
  label: PropTypes.string,
};

export default AddressCheckBox;
